'use strict';

module.exports = global;



/*****************
 ** WEBPACK FOOTER
 ** ./~/globalthis/implementation.js
 ** module id = 997
 ** module chunks = 0
 **/